import store from "../index.js";
import api from "../../utils/api";
import { INSURANCE_CANCEL_TYPE } from "../../enum/insurance";

export const modules = {
  store,
};

export const state = {
  _items: [],
  _item: {},
  _notiHistory: [],
  _page: {},
  _reviewCount: undefined,
};

export const mutations = {
  setInsuranceList(state, item) {
    state._items = [];
    state._items = item.items;
    state._page = item.page;
  },
  setInsuranceCounts(state, item) {
    state._reviewCount = item.totalReviewCount;
  },
  setInsuranceDetail(state, item) {
    state._item = item;
  },
  setInsuranceNotiHistory(state, item) {
    state._notiHistory = item;
  },
};

export const actions = {
  async acInsuranceList({ commit }, { stdate, endate, page, pageSize, email, status }) {
    const url = "/api/v1/insurance/list";
    try {
      const res = await api.get(`${url}`, {
        params: { stdate, endate, page, pageSize, email, status },
      });
      if (res.data?.code === 0 && res.data.data) {
        const page = {
          pageSize: res.data.data.pageSize,
          totalCount: res.data.data.totalCount,
          totalPage: res.data.data.totalPage,
        };
        commit("setInsuranceList", {
          page: page,
          items: res.data.data.items,
        });
      }
    } catch (error) {
      return false;
    }
  },
  async acInsuranceCounts({ commit }) {
    const url = "/api/v1/insurance/counts";
    try {
      const res = await api.get(`${url}`);
      if (res.data?.code === 0 && res.data.data) {
        commit("setInsuranceCounts", res.data.data);
      }
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acInsuranceSummary({ commit }, { subscribeSeq }) {
    const url = `/api/v1/insurance/summary/${subscribeSeq}`;
    try {
      const res = await api.get(`${url}`);
      const success = res.data?.code === 0 && res.data?.data !== null;
      if (success) {
        return res.data.data;
      } else {
        return null;
      }
    } catch (error) {
      // window.console.log("acInsuranceSummary error: ", error);
      return null;
    }
  },
  async acInsuranceDetail({ commit }, { insuranceSeq }) {
    const url = `/api/v1/insurance/detail/${insuranceSeq}`;
    try {
      const res = await api.get(`${url}`);
      if (res.data?.code === 0 && res.data.data) {
        commit("setInsuranceDetail", res.data.data);
      }
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acInsuranceDataUpdate({ commit }, { insuranceSeq, insuranceData }) {
    const url = `/api/v1/insurance/data/${insuranceSeq}`;
    try {
      const res = await api.patch(`${url}`, {
        insurance_data: insuranceData,
      });
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acInsuranceApprove({ commit }, { insuranceSeq }) {
    const url = `/api/v1/insurance/approve/${insuranceSeq}`;
    try {
      const res = await api.post(`${url}`);
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acInsuranceDecline({ commit }, { insuranceSeq }) {
    const url = `/api/v1/insurance/decline/${insuranceSeq}`;
    try {
      const res = await api.post(`${url}`);
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acInsuranceCancel({ commit }, { insuranceSeq, cancelType }) {
    if (![INSURANCE_CANCEL_TYPE.REVOKE, INSURANCE_CANCEL_TYPE.TERMINATE].includes(cancelType)) {
      return false;
    }
    const cancelPath = cancelType;
    const url = `/api/v1/insurance/${cancelPath}/${insuranceSeq}`;
    try {
      const res = await api.post(`${url}`);
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  // 재발급(계약기간 정정 → 새 코드 신규 발급). 소유자 전용(reissueSecret 필요).
  async acInsuranceReissue({ commit }, { insuranceSeq, contractStartDate, contractEndDate, reissueSecret, dryRun }) {
    const url = `/api/v1/insurance/reissue/${insuranceSeq}`;
    try {
      const res = await api.post(`${url}`, {
        contractStartDate,
        contractEndDate,
        reissueSecret,
        dryRun,
      });
      if (res.data?.code === 0) {
        return { ok: true, data: res.data.data };
      }
      return { ok: false, message: res.data?.message || "재발급 실패" };
    } catch (error) {
      return { ok: false, message: error?.data?.message || "재발급 실패" };
    }
  },
  async acInsuranceStats({ commit }, { startDate, endDate }) {
    const url = `/api/v1/insurance/stats?start_date=${startDate}&end_date=${endDate}`;
    try {
      const res = await api.get(`${url}`);
      const success = res.data?.code === 0 && res.data?.data !== null;
      if (success) {
        return res.data.data;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
  async acGenerateInsuranceCertificate({ commit }, { insuranceSeq }) {
    const url = `/api/v1/insurance/certificate/${insuranceSeq}`;
    try {
      const res = await api.post(`${url}`);
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
